import React, { useEffect, useState } from 'react'
import moment from 'moment'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import API from '../../../../../services/API'
import { Cancel, CheckCircle } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { Alert, Box, LinearProgress, Stack, Typography } from '@mui/material'

const Incidents = () => {
  const [loading, setLoading] = useState(true)
  const [reports, setReports] = useState([])
  const [fetchError, setFetchError] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    API.get('/client-portal/riddor-reports-fetch-all')
      .then((res) => {
        if (res.status === 200) {
          setReports(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Stack gap={1} width="100%">
      <Typography variant="title2">H&S Incidents</Typography>
      {loading && <LinearProgress />}
      {fetchError ? (
        <Alert severity="error">
          Unable to load Incidents. Please try again later.
        </Alert>
      ) : (
        <CustomDataGrid
          columns={[
            {
              field: 'incidentDate',
              headerName: 'Date',
              valueGetter: (value, row) => row.incident.incidentDate,
              renderCell: ({ value }) =>
                moment(value).format('Do MMM YYYY HH:mm'),
              minWidth: 160,
            },
            {
              field: 'event',
              headerName: 'Event',
              valueGetter: (value, row) => row.incident.linkedEvent.title,
              minWidth: 200,
              flex: 1,
            },
            {
              field: 'type',
              headerName: 'Incident Type',
              valueGetter: (value, row) => row.incident?.healthSafetyType ?? [],
              renderCell: ({ value }) => value.join(', '),
              minWidth: 120,
              flex: 1,
            },
            {
              field: 'ptOutcome',
              headerName: 'Patient Outcome',
              valueGetter: (value, row) => row?.plan?.ptOutcome,
              minWidth: 120,
              flex: 1,
            },
            {
              field: 'reviewed',
              headerName: 'Reviewed',
              headerAlign: 'center',
              valueGetter: (value, row) =>
                row.incident.healthSafetyConcernReviewedByOrganiser,
              renderCell: ({ value }) => (
                <Box display="flex" justifyContent="center" width="100%">
                  {value ? (
                    <CheckCircle color="success" />
                  ) : (
                    <Cancel color="error" />
                  )}
                </Box>
              ),
              minWidth: 120,
            },
          ]}
          rows={reports}
          slots={{
            toolbar: () => null,
            footer: () => null,
          }}
          disableRowSelectionOnClick
          onRowClick={({ row }) =>
            navigate('/health-safety-incidents/' + row._id)
          }
        />
      )}
    </Stack>
  )
}

export default Incidents
